module.exports = "/timeclock/components/viewTimesheetModal-50ecc3.html";